import { stakeholderModel } from './models.js';

export const stakeholderOperationPortalPrivileges = [
  // sop reporting

  {
    id: 2001,
    typeId: 20,
    labelKey: 'drugCount'
  },
  {
    id: 2002,
    typeId: 20,
    labelKey: 'drugList'
  },
  {
    id: 2003,
    typeId: 20,
    labelKey: 'expiredDrugList'
  },
  {
    id: 2004,
    typeId: 20,
    labelKey: 'operationList'
  },
  // sop product operations
  {
    id: 2101,
    typeId: 21,
    labelKey: 'productQuery'
  },
  {
    id: 2102,
    typeId: 21,
    labelKey: 'productTransactionQuery'
  },
  {
    id: 2103,
    typeId: 21,
    labelKey: 'supplyNotificationLog'
  },
  {
    id: 2104,
    typeId: 21,
    labelKey: 'prescriptionQuery'
  },
  {
    id: 2105,
    typeId: 21,
    labelKey: 'incomingUnitQuery'
  },
  // sop drug operations
  {
    id: 2201,
    typeId: 22,
    labelKey: 'listingDrug' // my drugs
  },
  // sop sh operations
  {
    id: 2301,
    typeId: 23,
    labelKey: 'listingStakeholders'
  },
  // sop help desk
  {
    id: 2401,
    typeId: 24,
    labelKey: 'listingTickets'
  },
  {
    id: 2402,
    typeId: 24,
    labelKey: 'createTicket'
  },
  // sop User Operations
  {
    id: 2501,
    typeId: 25,
    labelKey: 'listingUsers'
  },
  {
    id: 2502,
    typeId: 25,
    labelKey: 'createEditUser'
  },
  {
    id: 2504,
    typeId: 25,
    labelKey: 'resetUserPassword'
  },
  {
    id: 2505,
    typeId: 25,
    labelKey: 'User Change Status'
  },
  // sop My Notifications
  {
    id: 2601,
    typeId: 26,
    labelKey: 'dispatchPackages'
  },
  {
    id: 2602,
    typeId: 26,
    labelKey: 'acceptPackages'
  },
  // sop Offer/Demand Operations
  {
    id: 2701,
    typeId: 31,
    labelKey: 'listingOffers'
  },
  {
    id: 2702,
    typeId: 31,
    labelKey: 'createEditOffer'
  },
  {
    id: 2708,
    typeId: 31,
    labelKey: 'createEditDemand"'
  },
  {
    id: 2709,
    typeId: 31,
    labelKey: 'listingDemand'
  },
  // sop Drug Shortage Operations
  {
    id: 2801,
    typeId: 32,
    labelKey: 'listDrugShortage'
  },
  {
    id: 2802,
    typeId: 32,
    labelKey: 'editDrugShortage'
  }
];
export const privilegesType = {
  REPORT: 10, // MP
  PRODUCT_OPERATION: 11,
  STAKEHOLDER_OPERATION: 12,
  USER_OPERATION: 13,
  DRUG_OPERATIONS: 14,
  MP_HELP_DESK: 15,
  PORTAL_MANAGEMENT: 17,
  BLOCK_RECALL_OPERATION: 18,
  SYATEM_MANAGEMENT: 19,
  OFFER_DEMAND_OPERATIONS: 33,
  REPORTING: 20, // SP
  PRODUCT_OPERATIONS: 21,
  DRUGS_OPERATIONS: 22,
  STAKEHOLDER_OPERATIONS: 23,
  SP_HELP_DESK: 24,
  USER_OPERATIONS: 25,
  MY_NOTIFICATIONS: 26,
  OFFER_DEMAND_OPERATION: 31,
  DRUG_SHORTAGE_OPERATION: 32,
  SERVICE: -1, // SCو
  BLACKLIST_OPERATIONS: 34
};

export const managementPortalPrivilegesObject = {
  drugListOverSerialNumber: {
    id: 5001,
    typeId: 10
  },
  drugCountOverRegistrationNumber: {
    id: 5002,
    typeId: 10
  },
  drugCountOverStakeholderType: {
    id: 1001,
    typeId: 10
  },
  drugCountOverStakeholder: {
    id: 1002,
    typeId: 10
  },
  drugListOverStakeholder: {
    id: 1003,
    typeId: 10
  },
  expiredDrugList: {
    id: 1004,
    typeId: 10
  },
  blockedDrugCountList: {
    id: 1005,
    typeId: 10
  },
  blockedDrugList: {
    id: 1006,
    typeId: 10
  },
  recalledDrugCountList: {
    id: 1007,
    typeId: 10
  },
  recalledDrugList: {
    id: 1008,
    typeId: 10
  },
  nonsuppliedDrugList: {
    id: 1009,
    typeId: 10
  },
  sideEffectCountList: {
    id: 1010,
    typeId: 10
  },
  batchStatusList: {
    id: 1011,
    typeId: 10
  },
  zeroStockDrugCountList: {
    id: 1012,
    typeId: 10
  },
  suppliedDrugList: {
    id: 1013,
    typeId: 10
  },
  generalSuppliedDrugList: {
    id: 1014,
    typeId: 10
  },
  drugStatus: {
    id: 1015,
    typeId: 10
  },
  generalDrugStatus: {
    id: 1016,
    typeId: 10
  },
  blockedDrugs: {
    id: 1017,
    typeId: 10
  },
  generalBlockedDrugs: {
    id: 1018,
    typeId: 10
  },
  recalledDrugs: {
    id: 1019,
    typeId: 10
  },
  generalRecalledDrugs: {
    id: 1020,
    typeId: 10
  },
  notificationLogList: {
    id: 1021,
    typeId: 10
  },
  webserviceLogList: {
    id: 1022,
    typeId: 10
  },
  pharmacySaleList: {
    id: 1023,
    typeId: 10
  },
  drugStakeholderList: {
    id: 1024,
    typeId: 10
  },
  stakeholderOperationSourceList: {
    id: 1025,
    typeId: 10
  },
  stockMatch: {
    id: 5007,
    typeId: 10
  },
  productQuery: {
    id: 1101,
    typeId: 11
  },
  supplyNotificationLog: {
    id: 1102,
    typeId: 11
  },
  undefinedProduct: {
    id: 1103,
    typeId: 11
  },
  sideEffectList: {
    id: 1104,
    typeId: 11
  },
  updateExpireDate: {
    id: 1105,
    typeId: 11
  },
  undefinedServiceProduct: {
    id: 1106,
    typeId: 11
  },
  updateBatchNumber: {
    id: 1107,
    typeId: 11
  },
  updateManufactureDate: {
    id: 5003,
    typeId: 11
  },
  GLNUpdate: {
    id: 5004,
    typeId: 11
  },
  listingStakeholders: {
    id: 1201,
    typeId: 12
  },
  createEditStakeholder: {
    id: 1202,
    typeId: 12
  },
  listPendingStakeholder: {
    id: 1203,
    typeId: 12
  },
  firstApproveStakeholder: {
    id: 1204,
    typeId: 12
  },
  lastApproveStakeholder: {
    id: 1205,
    typeId: 12
  },
  denyStakeholder: {
    id: 1206,
    typeId: 12
  },
  companyList: {
    id: 1207,
    typeId: 12
  },
  companyCreateEdit: {
    id: 1208,
    typeId: 12
  },
  incentiveManagement: {
    id: 1209,
    typeId: 12
  },
  listingDrugShortage: {
    id: 1210,
    typeId: 12
  },
  editDrugShortage: {
    id: 1211,
    typeId: 12
  },
  unregisteredDrugsRequests: {
    id: 5008,
    typeId: 12
  },
  listingBlacklistUsers: {
    id: 2913,
    typeId: 34
  },
  listingManagementUsers: {
    id: 1301,
    typeId: 13
  },
  createEditManagementUser: {
    id: 1302,
    typeId: 13
  },
  deleteManagementUser: {
    id: 1303,
    typeId: 13
  },
  resetPasswordManagementUser: {
    id: 1304,
    typeId: 13
  },
  listingStakeholderUsers: {
    id: 1305,
    typeId: 13
  },
  createEditStakeholderUser: {
    id: 1306,
    typeId: 13
  },
  deleteStakeholderUser: {
    id: 1307,
    typeId: 13
  },
  resetPasswordStakeholderUser: {
    id: 1308,
    typeId: 13
  },
  userChangeStatus: {
    id: 1309,
    typeId: 13
  },
  listingDrugs: {
    id: 1401,
    typeId: 14
  },
  createEditDrug: {
    id: 1402,
    typeId: 14
  },
  listingTickets: {
    id: 1501,
    typeId: 15
  },
  replyTicket: {
    id: 1502,
    typeId: 15
  },
  listingAnnouncement: {
    id: 1701,
    typeId: 17
  },
  createEditAnnouncement: {
    id: 1702,
    typeId: 17
  },
  deleteAnnouncement: {
    id: 1703,
    typeId: 17
  },
  listingMails: {
    id: 1704,
    typeId: 17
  },
  contentDetailView: {
    id: 1705,
    typeId: 17
  },
  createEditMailSettings: {
    id: 1706,
    typeId: 17
  },
  errorMessagesView: {
    id: 1707,
    typeId: 17
  },
  listingBlockNotifications: {
    id: 1801,
    typeId: 18
  },
  notifyBlock: {
    id: 1802,
    typeId: 18
  },
  approveBlock: {
    id: 1803,
    typeId: 18
  },
  notifyBlockCancel: {
    id: 1805,
    typeId: 18
  },
  notifyBlockCancelAndRecall: {
    id: 1806,
    typeId: 18
  },
  denyBlockNotification: {
    id: 1807,
    typeId: 18
  },
  blockedProductsExcel: {
    id: 1808,
    typeId: 18
  },
  listingRecallNotifications: {
    id: 1809,
    typeId: 18
  },
  notifyRecall: {
    id: 1810,
    typeId: 18
  },
  approveRecall: {
    id: 1811,
    typeId: 18
  },
  notifyRecallCancel: {
    id: 1813,
    typeId: 18
  },
  denyRecallNotification: {
    id: 1814,
    typeId: 18
  },
  recalledProductsExcel: {
    id: 1815,
    typeId: 18
  },
  systemHealthMonitoring: {
    id: 1901,
    typeId: 19
  },
  systemParameters: {
    id: 1902,
    typeId: 19
  },
  drugSaleLimitation: {
    id: 1903,
    typeId: 19
  },
  deactivationReasonMatrix: {
    id: 1904,
    typeId: 19
  },
  statusMatrix: {
    id: 1905,
    typeId: 19
  },
  createEditLabels: {
    id: 5005,
    typeId: 19
  },
  listingDemand: {
    id: 2908,
    typeId: 33
  },
  editDemand: {
    id: 2909,
    typeId: 33
  },
  assignMedicalEstDrugShortageReportAssigner: {
    id: 2910,
    typeId: 33
  },
  assignMedicalEstDrugShortageReport: {
    id: 2911,
    typeId: 33
  },
  listingOffers: {
    id: 2903,
    typeId: 33
  },
  editOffers: {
    id: 2904,
    typeId: 33
  },
  viewMedicalEstablishmentDrugShortage: {
    id: 2906,
    typeId: 33
  },
  replyMedicalEstablishmentDrugShortage: {
    id: 2907,
    typeId: 33
  },
  subscribedListing: {
    id: 2915,
    typeId: -1
  },
  redistributionDemandList: {
    id: 2917,
    typeId: 33
  }
};
export const stakeholderOperationPortalPrivilegesObject = {
  supplyProductNotification: { id: 100, typeId: 30 },
  acceptNotification: { id: 101, typeId: 30 },
  returnNotification: { id: 102, typeId: 30 },
  dispatchNotification: { id: 103, typeId: 30 },
  dispatchCancelNotification: { id: 104, typeId: 30 },
  exportNotification: { id: 105, typeId: 30 },
  deactivationNotification: { id: 106, typeId: 30 },
  checkStatus: { id: 108, typeId: 30 },
  pharmacySaleNotification: { id: 109, typeId: 30 },
  pharmacySaleCancelNotification: { id: 110, typeId: 30 },
  consumeNotification: { id: 111, typeId: 30 },
  consumeCancelNotification: { id: 112, typeId: 30 },
  exportCancelNotification: { id: 113, typeId: 30 },
  transferNotification: { id: 114, typeId: 30 },
  transferCancelNotification: { id: 115, typeId: 30 },
  blockNotification: { id: 116, typeId: 30 },
  blockCancelNotification: { id: 117, typeId: 30 },
  recallNotification: { id: 118, typeId: 30 },
  importNotification: { id: 119, typeId: 30 },
  blockCancelAndRecallNotification: { id: 120, typeId: 30 },
  recallCancelNotification: { id: 121, typeId: 30 },
  supplyCancelNotification: { id: 122, typeId: 30 },
  importCancelNotification: { id: 123, typeId: 30 },
  deactivationCancelNotification: { id: 124, typeId: 30 },
  dispatchAcceptNotification: { id: 125, typeId: 30 },
  acceptByBatchNumber: { id: 126, typeId: 30 },
  dispatchByBatchNumber: { id: 127, typeId: 30 },
  returnByBatchNumber: { id: 128, typeId: 30 },
  transferByBatchNumber: { id: 129, typeId: 30 },
  dispatchCancelByBatchNumber: { id: 104, typeId: 30 }, // todo update id
  transferCancelByBatchNumber: { id: 115, typeId: 30 }, // todo update id

  drugCount: {
    id: 2001,
    typeId: 20
  },
  drugList: {
    id: 2002,
    typeId: 20
  },
  expiredDrugList: {
    id: 2003,
    typeId: 20
  },
  operationList: {
    id: 2004,
    typeId: 20
  },
  stockMatch: {
    id: 5006,
    typeId: 20
  },
  productQuery: {
    id: 2101,
    typeId: 21
  },
  productTransactionQuery: {
    id: 2102,
    typeId: 21
  },
  supplyNotificationLog: {
    id: 2103,
    typeId: 21
  },
  prescriptionQuery: {
    id: 2104,
    typeId: 21
  },
  incomingUnitQuery: {
    id: 2105,
    typeId: 21
  },
  listingDrug: {
    id: 2201,
    typeId: 22
  },
  listingStakeholders: {
    id: 2301,
    typeId: 23
  },
  listingTickets: {
    id: 2401,
    typeId: 24
  },
  createTicket: {
    id: 2402,
    typeId: 24
  },
  listingUsers: {
    id: 2501,
    typeId: 25
  },
  createEditUser: {
    id: 2502,
    typeId: 25
  },
  resetUserPassword: {
    id: 2504,
    typeId: 25
  },
  'User Change Status': {
    id: 2505,
    typeId: 25
  },
  dispatchPackages: {
    id: 2601,
    typeId: 26
  },
  acceptPackages: {
    id: 2602,
    typeId: 26
  },
  listingOffers: {
    id: 2701,
    typeId: 31
  },
  createEditOffer: {
    id: 2702,
    typeId: 31
  },
  createEditDemand: {
    id: 2708,
    typeId: 31
  },
  listingDemand: {
    id: 2709,
    typeId: 31
  },
  offerToDemand: {
    id: 2705,
    typeId: 31
  },
  viewMedicalEstablishmentDrugShortage: {
    id: 2706,
    typeId: 31
  },
  createMedicalEstablishmentDrugShortage: {
    id: 2707,
    typeId: 31
  },
  listDrugShortage: {
    id: 2801,
    typeId: 32
  },
  editDrugShortage: {
    id: 2802,
    typeId: 32
  },
  redistributionDemandList: {
    id: 2916,
    typeId: 31
  }
};
// Us > SH Us > Edit
export const stakeholderUsersServicePrivileges = [
  {
    id: 100,
    typeId: -1,
    labelKey: 'SUPPLY'
  },
  {
    id: 101,
    typeId: -1,
    labelKey: 'ACCEPT'
  },
  {
    id: 102,
    typeId: -1,
    labelKey: 'RETURN'
  },
  {
    id: 103,
    typeId: -1,
    labelKey: 'DISPATCH'
  },
  {
    id: 104,
    typeId: -1,
    labelKey: 'DISPATCH CANCEL'
  },
  {
    id: 105,
    typeId: -1,
    labelKey: 'EXPORT'
  },
  {
    id: 106,
    typeId: -1,
    labelKey: 'DEACTIVATE'
  },
  {
    id: 108,
    typeId: -1,
    labelKey: 'CHECK STATUS'
  },
  {
    id: 109,
    typeId: -1,
    labelKey: 'PHARMACY SALE'
  },
  {
    id: 110,
    typeId: -1,
    labelKey: 'PHARMACY SALE CANCEL'
  },
  {
    id: 111,
    typeId: -1,
    labelKey: 'CONSUME'
  },
  {
    id: 112,
    typeId: -1,
    labelKey: 'CONSUME CANCEL'
  },
  {
    id: 113,
    typeId: -1,
    labelKey: 'EXPORT CANCEL'
  },
  {
    id: 114,
    typeId: -1,
    labelKey: 'TRANSFER'
  },
  {
    id: 115,
    typeId: -1,
    labelKey: 'TRANSFER CANCEL'
  },
  {
    id: 119,
    typeId: -1,
    labelKey: 'IMPORT'
  },
  {
    id: 122,
    typeId: -1,
    labelKey: 'SUPPLY CANCEL'
  },
  {
    id: 123,
    typeId: -1,
    labelKey: 'IMPORT CANCEL'
  },
  {
    id: 124,
    typeId: -1,
    labelKey: 'DEACTIVATE CANCEL'
  },
  {
    id: 125,
    typeId: -1,
    labelKey: 'DISPATCH ACCEPT'
  },
  {
    id: 126,
    typeId: -1,
    labelKey: 'ACCEPT BY BATCH NUMBER'
  },
  {
    id: 127,
    typeId: -1,
    labelKey: 'DISPATCH BY BATCH NUMBER'
  },
  {
    id: 128,
    typeId: -1,
    labelKey: 'Return BY BATCH NUMBER'
  },
  {
    id: 129,
    typeId: -1,
    labelKey: 'Transfer BY BATCH NUMBER'
  }
];

export const domains = [ { id: stakeholderModel.DOMAINS.HUMAN }, { id: stakeholderModel.DOMAINS.VET } ];
